import { useState, useCallback } from "react";
import { showMessage } from "react-native-flash-message";
import { getEnv } from "../helpers/general";
import { Platform } from "react-native";
import { requestHelper } from "../helpers/request-helper";

export default useAddCredit;

function addCreditApi({ amount, order_id, origin, address_id, period_id }) {
  let qs = [];
  qs.push(`platform=${Platform.OS}`);
  if (origin) {
    qs.push(`origin=${origin}`);
  }
  if (order_id) {
    qs.push(`order_id=${order_id}`);
  }
  if (address_id) {
    qs.push(`address_id=${address_id}`);
  }
  if (period_id) {
    qs.push(`period_id=${period_id}`);
  }
  let queryString = qs.join("&");
  return requestHelper(
    `
        mutation addCredit(
          $amount: Int!
          $callback_url: String!
          $gateway_unique_id: String!
          $order_id: Int
        ) {
          proxyChargeWallet(
            amount: $amount
            callback_url: $callback_url
            gateway_unique_id: $gateway_unique_id
            order_id: $order_id
          ) {
            pay_id
            psp_payment_url
          }
        }
      `,
    {
      amount: amount,
      callback_url: `${getEnv(
        "REACT_APP_PAYMENT_CALLBACK_URL"
      )}/?${queryString}`,
      gateway_unique_id: "198f9dfbc1dfab10c57ee7aef24566b2",
      order_id: order_id,
    }
  ).then((data) => {
    return data.proxyChargeWallet;
  });
}

function useAddCredit() {
  let [loading, setLoading] = useState(false);

  let addCredit = useCallback(async function addCredit_memo({
    amount,
    order_id,
    origin,
    address_id,
    period_id,
  }) {
    setLoading(true);

    try {
      let res = await addCreditApi({
        amount,
        order_id,
        origin,
        address_id,
        period_id,
      });

      showMessage({
        message: "تا لحظاتی دیگر به درگاه منتقل می‌شوید",
        type: "success",
      });

      return res;
    } catch (e) {
      let general_message = "مشکلی در درخواست افزایش اعتبار پیش آمده است.";
      if (e?.response?.errors) {
        general_message = e?.response?.errors[0]?.message;
      }

      throw general_message;
    } finally {
      setLoading(false);
    }
  },
  []);

  return {
    addCredit,
    loading,
  };
}
